import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loadingTimeslots: false,
	loadingMeals: false,
	loadingDrinks: false,
	loadingCreatingOrder: false,
	loadingMealCustomizations: false,
	loadingDrinkCustomizations: false,
	timeslots: [],
	meals: [],
	drinks: [],
	mealCustomizations: [],
	drinkCustomizations: [],
	order: null,
	checkout_url: null,
	meta: {}
};

export default function bookingPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_TIMESLOTS_REQUEST:
		case ActionTypes.GET_TIMESLOTS_ERROR:
		case ActionTypes.GET_TIMESLOTS_SUCCESS:
		case ActionTypes.GET_MEALS_REQUEST:
		case ActionTypes.GET_MEALS_ERROR:
		case ActionTypes.GET_MEALS_SUCCESS:
		case ActionTypes.GET_DRINKS_REQUEST:
		case ActionTypes.GET_DRINKS_ERROR:
		case ActionTypes.GET_DRINKS_SUCCESS:
		case ActionTypes.CREATE_ORDER_REQUEST:
		case ActionTypes.CREATE_ORDER_ERROR:
		case ActionTypes.CREATE_ORDER_SUCCESS:
		case ActionTypes.GET_MEAL_CUSTOMIZATIONS_REQUEST:
		case ActionTypes.GET_MEAL_CUSTOMIZATIONS_ERROR:
		case ActionTypes.GET_MEAL_CUSTOMIZATIONS_SUCCESS:
		case ActionTypes.GET_DRINK_CUSTOMIZATIONS_REQUEST:
		case ActionTypes.GET_DRINK_CUSTOMIZATIONS_ERROR:
		case ActionTypes.GET_DRINK_CUSTOMIZATIONS_SUCCESS:
		case ActionTypes.CLEAR_MEAL_CUSTOMIZATIONS:
		case ActionTypes.CLEAR_DRINK_CUSTOMIZATIONS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_BOOKING_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_BOOKING_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
